<template>
  <span>
    <v-icon @click.stop="dialogClicked()">delete</v-icon>
    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">delete</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Delete User</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          Are you sure you want to delete user<br />
          '{{ user.name }}' with email {{ user.email }}?
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>

          <v-btn color="error" @click="deleteUser">
            <v-icon left>delete</v-icon> Delete User</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {},
  methods: {
    async deleteUser() {
      if (this.user == null) return;
      let user_url = `/api/users/${this.user.id}`;
      axios.delete(user_url).then(({ _data }) => {
        this.$emit('userDeleted', true);
        this.dialog = false;
      });
    },
    dialogClicked() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped></style>
